/**
 * Constantes para o componente Result Member Profile
 */

import { AVATAR_FIELDS, NAME_FIELDS } from '../shared/avatar/avatar.constants';

/**
 * Campos que devem ser excluídos do perfil (já mostrados no header ou ocultos)
 */
export const EXCLUDED_PROFILE_FIELDS = [
    ...AVATAR_FIELDS,
    ...NAME_FIELDS,
    'genero', 'gender', 'sexo',
    'ativo', 'activated', 'active'
];

/**
 * Mapeamento de labels para campos do perfil
 */
export const PROFILE_FIELD_LABELS: { [key: string]: string } = {
    'telefone': 'Telefone',
    'celular': 'Celular',
    'email': 'E-mail',
    'endereco': 'Endereço',
    'cidade': 'Cidade',
    'bairro': 'Bairro',
    'cep': 'CEP',
    'estado_civil': 'Estado Civil',
    'profissao': 'Profissão',
    'nascimento': 'Nascimento',
    'batismo': 'Batismo',
    'data_batismo': 'Data Batismo',
    'data_cadastro': 'Cadastro',
    'cpf': 'CPF',
    'rg': 'RG',
    'tipo': 'Tipo',
    'funcao': 'Função',
    'cargo': 'Cargo',
    'grupo': 'Grupo',
    'divisao': 'Divisão'
};

/**
 * Verifica se um campo deve ser excluído do perfil
 */
export function isExcludedField(key: string): boolean {
    return EXCLUDED_PROFILE_FIELDS.includes(key.toLowerCase());
}

/**
 * Obtém o label para um campo do perfil
 */
export function getProfileFieldLabel(key: string): string {
    const lowerKey = key.toLowerCase();

    if (PROFILE_FIELD_LABELS[lowerKey]) {
        return PROFILE_FIELD_LABELS[lowerKey];
    }

    // Converte snake_case para Title Case
    return key
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

/**
 * Detecta se os dados representam um perfil de membro
 */
export function isMemberProfileData(data: any[] | null): boolean {
    if (!data || data.length !== 1) return false;

    const keys = Object.keys(data[0]).map(k => k.toLowerCase());

    // Verifica se tem campo de nome
    const hasNameField = NAME_FIELDS.some(f => keys.includes(f.toLowerCase()));

    // Verifica se tem campo de foto
    const hasPhotoField = AVATAR_FIELDS.some(f => keys.includes(f.toLowerCase()));

    return hasNameField || hasPhotoField;
}
